module.exports = __webpack_public_path__ + "img/16.e509eafd.svg";